export function renderMenuData(data, level = 0) {
  const indent = level * 16;
  const toggleId = `cat-${data.category_id}`;
  const breadcrumbText = data.category_breadcrumb.join(' › ');

  let HTML = '';

  let childrenHTML = '';
  if (data.children && data.children.length > 0) {
    for (const child of data.children) {
      childrenHTML += renderMenuData(child, level + 1);
    }
  }

  if (data.posts && data.posts.length > 0) {
    HTML += `<div class="w-full category-block">`;

    HTML += `
      <div class="w-full flex justify-between text-sm font-bold category-header cursor-pointer py-4 items-center text-[#3B6CDC]" 
           data-toggle-id="${toggleId}">
           <span>${breadcrumbText}</span>
           <span class="ml-4 flex items-center justify-center shrink-0">
  <i class="toggleMenuIcon fal fa-chevron-right rotate-90"></i>
</span>
      </div>`;

    HTML += `<div class="category-content mt-2 block" id="${toggleId}">`;

    HTML += `<ul class="posts-list">`;
    for (const post of data.posts) {
      const thumbnail = post.thumbnail || 'https://course.kiem.vn/wp-content/uploads/2025/06/huou-scaled.png';
      const isActive = decodeURIComponent(window.location.href) === decodeURIComponent(post.permalink);
      HTML += `
        <li class="py-4 border-t border-dotted border-[#DDD] hover:bg-gray-100 ${isActive ? 'bg-blue-100 active' : ''}">
          <a class="flex flex-row items-center hover:text-[#3B6CDC]" href="${post.permalink}">
          <i class="fal fa-book"></i>
          <!-- <img class="flex-shrink-0 w-[168px] h-[108px] rounded-lg" src="${thumbnail}" alt="Thumbnail" /> -->
            <div class="metadata flex-1 ml-4">
              <h3 class="text-base font-bold">${post.title}</h3>
              <p class="text-sm">Kiềm Thảo Dược Saphia</p>
              <p class="text-sm">${post.date}</p>
            </div>
          </a>
        </li>`;
    }
    HTML += `</ul>`;

    HTML += childrenHTML;

    HTML += `</div></div>`;
  }

  else if (childrenHTML) {
    HTML += childrenHTML;
  }

  return HTML;
}
